import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { FlatList } from "react-native";
import { useIsFocused } from "@react-navigation/native";
import i18n from 'i18n-js';
import { backendRequest } from "../../stores/thunks";
import { selectGiftableStudioTasks } from "../../stores/selectors";
import WorkflowCard from "../components/basic/WorkflowCard";
import Filter from "../components/basic/Filter";
import { IconMC } from '../../components/media/IconsV2';
import ModalGift from '../components/modals/ModalGift';
import Moment from 'moment';
import Toast from '../components/basic/Toast';

export default function Community({ navigation }) {
    const isFocused = useIsFocused();

    const marketTasks = useSelector((state) => state.market)
    const studioTasks = useSelector(selectGiftableStudioTasks)
    const changed = useSelector((state) => state.settings.changed || [])

    const sorts = ['searchScreen.newest', 'searchScreen.topVote', 'searchScreen.topLoad']
    const categories = ['taskSettings.any', 'taskSettings.home', 'taskSettings.garden', 'taskSettings.allday', 'taskSettings.medic', 'taskSettings.diy', 'taskSettings.cook', 'taskSettings.other']

    const [filteredList, setFilteredList] = useState([])
    const [search, setSearch] = useState('')
    const [sort, setSort] = useState(0)
    const [mine, setMine] = useState(false)
    const [toast, setToast] = useState(false)
    const [category, setCategory] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (isFocused) {
            refreshData()
        }
        console.log('STUDIO',studioTasks)
    }, [isFocused])

    const searchWorkflows = (element) => {
        return search == '' || (element.data.title || i18n.t('studio.main.noTitle')).toLowerCase().includes(search.toLowerCase())
    }

    const filterWorkflows = (element) => {
        return (!mine || element.isowned) && (!category || category == 0 || category == (+element.stats.category || 7))
    }

    useEffect(() => {
        console.log('MARKET', sort, marketTasks)
        if (marketTasks != undefined) {
            setFilteredList(
                marketTasks.filter(element => searchWorkflows(element) && filterWorkflows(element))
                    .sort((a, b) => sort == 0 ? new Moment(b.createdat).format('YYYYMMDD') - new Moment(a.createdat).format('YYYYMMDD') : sort == 1 ? b.likecount - a.likecount : b.takecount - a.takecount)
            )
        }
    }, [marketTasks, search, sort, category, mine])

    function refreshData() {
        dispatch(backendRequest('GET_WORKFLOWS_INLINE', '/contact/user', null, 'GET', false))
    }

    const onClose = () => {
        setShowModal(false)
        refreshData()
    }

    function removeMarketItem(marketId) {
        console.log('UNDONATE', marketId)
        dispatch(backendRequest('STUDIO_UNDONATE', '/market/' + marketId, null, 'DELETE', false))
    }

    function takeMarketItem(marketId, title) {
        console.log('TAKE', marketId)
        setToast(true)
        setTimeout(() => setToast(false), 5000)
        dispatch(backendRequest('STUDIO_TAKE', '/market/take/' + marketId, null, 'POST', false))
    }

    function likeMarketItem(marketId) {
        console.log('LIKE', marketId)
        dispatch(backendRequest('STUDIO_TAKE', '/market/like/' + marketId, null, 'PUT', false))
    }

    return (
        <View className="flex-1">
            <VStack className="flex-1 h-[100%] pt-9 px-10 pb-9 items-center overflow-y-scroll overflow-x-clip">
                <VStack space="2xl" className="flex-none max-w-[100%] w-[1100px]">
                    <Text className="text-2xl font-[700] text-secondary-900 ml-2 mb-2">{i18n.t('studio.market.marketplace')}</Text>
                    <Filter search={search} setSearch={setSearch} selectedTitle={'searchScreen.buttonMine'} selected={mine} setSelected={setMine}
                        filterTitle={'searchScreen.filterCat'} filters={categories} filter={category} setFilter={setCategory}
                        sortTitle={'searchScreen.sort'} sorts={sorts} sort={sort} setSort={setSort} />
                    <FlatList
                        data={filteredList}
                        renderItem={({ item }) => { return <WorkflowCard item={item} navigation={navigation} market={true} deleteItem={removeMarketItem} changed={changed.includes(item.id)} takeItem={takeMarketItem} likeItem={likeMarketItem} /> }}
                        keyExtractor={(item) => item?.id + item?.title + item?.text}
                        contentContainerStyle={{ flexDirection: "row", flexWrap: "wrap" }}
                        ListHeaderComponent={
                            <Pressable hardShadow='3' onPress={() => setShowModal(true)} className="justify-center items-center m-2 w-[200px] h-[200px] bg-secondary-50 rounded-md border-primary-900 border-[2px]">
                                <IconMC className='text-primary-900' size={96} name='gift-outline' />
                            </Pressable>}
                    />
                </VStack>
            </VStack>
            <Toast top='top-[10px]' right='right-[40px]' iconmc='gift-outline' title='studio.market.giftTaken' toast={toast} setToast={setToast} />
            {studioTasks && <ModalGift showModal={showModal} setShowModal={onClose} tasks={studioTasks} />}
        </View>
    );
}
